import { Series, Tool } from 'Explore/types';

export const filterOutCollectionsFromContent = (content: (Series | Tool)[]) =>
  content?.filter(
    (item: Series | Tool) =>
      !(item?.__typename === 'Series' && (item as Series).totalDays === 1),
  );
